export default "__VITE_ASSET__1DBZCJgh__"